"use client";

import { c as _c } from "react/compiler-runtime";
import { create } from "zustand";
import { persist } from "zustand/middleware";
import { usePersistHydration } from "@/lib/stores/persist-hydration";
interface UiState {
  announcementDismissed: boolean;
}
interface UiActions {
  dismissAnnouncement: () => void;
}
type UiStore = UiState & UiActions;
const uiStore = create<UiStore>()(persist(set => ({
  announcementDismissed: false,
  dismissAnnouncement: () => set({
    announcementDismissed: true
  })
}), {
  name: "ui",
  version: 1,
  partialize: state => ({
    announcementDismissed: state.announcementDismissed
  })
}));
export const useUiStore = uiStore;

/** Hidden until persist hydrates so dismissed users never see a flash. */
export function useAnnouncement() {
  const $ = _c(3);
  const dismissed = useUiStore(_temp);
  const dismiss = useUiStore(_temp2);
  const t0 = usePersistHydration(uiStore) && !dismissed;
  let t1;
  if ($[0] !== dismiss || $[1] !== t0) {
    t1 = {
      visible: t0,
      dismiss
    };
    $[0] = dismiss;
    $[1] = t0;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  return t1;
}
function _temp2(s_0) {
  return s_0.dismissAnnouncement;
}
function _temp(s) {
  return s.announcementDismissed;
}